import React from "react";
import { ReactComponent as ArrowIcon } from "../../../images/arrow-right.svg";
import './tertiary-custom-button.scss';

const TertiaryCustomButton = ({ 
  title = "Update Cart", 
  onClick, 
  classes, 
  href 
}) => {
  const className = classes ? `tertiary-button ${classes}` : "tertiary-button";

  if (href) {
    return (
      <a href={href} className={className}>
        <span>{title}</span>
        <ArrowIcon className="arrow-icon" />
      </a>
    );
  }

  return (
    <button className={className} onClick={onClick}>
      <span>{title}</span>
      <ArrowIcon className="arrow-icon" />
    </button>
  );
};

export default TertiaryCustomButton;
